import zhCN from 'element-plus/es/locale/lang/zh-cn';
import enUS from 'element-plus/es/locale/lang/en';
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { ref, reactive, computed } from 'vue';

export const useAppStore = defineStore('app', () => {
  const sidebar = reactive({
    // 侧栏固定展开，不再恢复旧版折叠偏好。
    opened: true,
    withoutAnimation: false,
    hide: false,
  });
  const device = ref<string>('desktop');
  const size = useStorage<'large' | 'default' | 'small'>('size', 'default');
  const appMainHei = ref(0);
  const appLogoNum = ref(0);

  // 语言
  const language = useStorage('language', 'zh_CN');
  const languageObj: any = {
    en_US: enUS,
    zh_CN: zhCN,
  };
  const locale = computed(() => {
    return languageObj[language.value];
  });

  const toggleDevice = (d: string): void => {
    device.value = d;
  };
  const SetAppMainHei = (y: number): void => {
    appMainHei.value = y;
  };
  const setAppLogoNum = (): void => {
    console.log('修改头像----------');

    appLogoNum.value = appLogoNum.value + 1;
  };
  const setSize = (s: 'large' | 'default' | 'small'): void => {
    size.value = s;
  };
  const toggleSideBarHide = (status: boolean): void => {
    sidebar.hide = status;
  };

  const changeLanguage = (val: string): void => {
    language.value = val;
  };

  return {
    device,
    sidebar,
    language,
    locale,
    size,
    appMainHei,
    appLogoNum,
    changeLanguage,
    toggleDevice,
    SetAppMainHei,
    setAppLogoNum,
    setSize,
    toggleSideBarHide,
  };
});
